import * as React from 'react';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import $script from 'scriptjs';
import { APPLE_CLIENTID, APPLE_REDIRECT } from '../../constants/login';
import { Field, Form } from 'react-final-form';
import { loginActions } from '../../store/login/actions';
import { Base64 } from 'js-base64';
import { bindActionCreators, Dispatch } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
import { userSelector } from '../../store/tipster/selector';
import { RootState } from '../../store';
import { Eye, EyeOff, Mail, Lock, CheckCircle } from 'lucide-react';
import NewTcLogo from '../../assets/NewTcLogo';
import queryString from 'query-string';
interface DispatchProps {
  actions: {
    newLoginRequest: (a: string, b: string) => void;
    newFBLoginRequest: (s: string) => any;
    newAppleLoginRequest: (token: string, email?: string, name?: string) => any;
  };
}
interface StateProps {
  user: any;
  isLoading: boolean;
  loginError: string | null;
}
interface OwnProps {}
type LoginProps = OwnProps & StateProps & DispatchProps & RouteComponentProps;

export const Login: React.FC<LoginProps> = (props) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const parsed = queryString.parse(props.location.search);
  const passwordReset = parsed.password_reset === 'true';
  // Prefilled by the signup "email already exists" CTA.
  const prefillEmail = typeof parsed.email === 'string' ? parsed.email : '';
  const required = (value: string) => (value ? undefined : tr(t, 'required'));
  const search = window.location.href.split('/login/sso?');
  const params = new URLSearchParams(search[1]);
  const redirect = params.get('redirect');

  useEffect(() => {
    const win: any = window;
    $script.get(
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
      () => {
        win.AppleID?.auth?.init({
          clientId: APPLE_CLIENTID,
          redirectURI: APPLE_REDIRECT,
          scope: 'name email',
          usePopup: true,
        });
      },
    );
  }, []);

  const onSubmit = (d: any) => {
    props.actions.newLoginRequest(
      Base64.toBase64(`${d.username}:${d.password}`),
      redirect || '',
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(to bottom left, #6633ff, #121619)' }}>
      <div className="w-full max-w-md">
        {props.user ? (
          <div className="bg-[#1a1f26] rounded-2xl shadow-2xl p-8 text-center border border-white/10">
            <h2 className="text-3xl font-bold text-white">
              Welcome to
              <br />
              TipsterChat
            </h2>
          </div>
        ) : (
          <div className="bg-[#1a1f26] rounded-2xl shadow-2xl p-8 space-y-6 border border-white/10">
            {passwordReset && (
              <div className="flex items-center gap-3 bg-green-500/10 border border-green-500/30 rounded-xl px-4 py-3">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                <p className="text-green-400 text-sm font-medium">
                  {tr(t, 'recover-pwd_success')}
                </p>
              </div>
            )}
            <div className="text-center space-y-4">
              <div className="flex items-center justify-center w-full">
                <img src="https://tipsterchat.com/assets/tipsterchat-logo.svg" />
              </div>
              <h2 className="text-3xl font-bold text-white">
                {tr(t, 'login_title')}
                <br />
                TipsterChat
              </h2>
            </div>

            <Form
              onSubmit={onSubmit}
              initialValues={{ username: prefillEmail }}
              //@ts-ignore
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <Field name="username" component="input" validate={required}>
                    {({ input, meta }) => (
                      <div className="space-y-2">
                        <div className="relative">
                          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
                          <input
                            {...input}
                            type="text"
                            placeholder={tr(t, 'login_username')}
                            className={`w-full pl-11 pr-4 py-3 bg-[#0f1318] border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6633ff] focus:border-transparent transition-all text-white placeholder-gray-500 ${
                              meta.error && meta.touched
                                ? 'border-red-500'
                                : 'border-white/10'
                            }`}
                          />
                        </div>
                        {meta.error && meta.touched && (
                          <p className="text-sm text-red-500 font-medium">
                            {meta.error}
                          </p>
                        )}
                      </div>
                    )}
                  </Field>

                  <Field name="password" component="input" validate={required}>
                    {({ input, meta }) => (
                      <div className="space-y-2">
                        <div className="relative">
                          <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
                          <input
                            {...input}
                            type={showPassword ? 'text' : 'password'}
                            placeholder={tr(t, 'login_password')}
                            className={`w-full pl-11 pr-12 py-3 bg-[#0f1318] border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6633ff] focus:border-transparent transition-all text-white placeholder-gray-500 ${
                              meta.error && meta.touched
                                ? 'border-red-500'
                                : 'border-white/10'
                            }`}
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300 transition-colors"
                          >
                            {showPassword ? (
                              <EyeOff className="w-5 h-5" />
                            ) : (
                              <Eye className="w-5 h-5" />
                            )}
                          </button>
                        </div>
                        {meta.error && meta.touched && (
                          <p className="text-sm text-red-500 font-medium">
                            {meta.error}
                          </p>
                        )}
                      </div>
                    )}
                  </Field>

                  {props.loginError && (
                    <div className="bg-red-500/10 border border-red-500/30 rounded-xl px-4 py-3">
                      <p className="text-red-400 text-sm font-medium">
                        {tr(t, 'login_error_wrong-pwd')}
                      </p>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={invalid || props.isLoading}
                    className="w-full py-3 px-4 bg-gradient-to-r from-[#6633ff] to-[#8855ff] text-white font-semibold rounded-xl hover:from-[#5522ee] hover:to-[#7744ff] transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {props.isLoading ? (
                      <svg className="animate-spin h-5 w-5 mx-auto text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    ) : (
                      tr(t, 'login_login')
                    )}
                  </button>

                  <div className="text-center">
                    <Link
                      to="/recover-password"
                      className="text-sm text-[#6633ff] font-semibold hover:text-[#5522ee] transition-colors"
                    >
                      {tr(t, 'login_recover-password')}
                    </Link>
                  </div>

                  <div className="relative">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t border-white/10"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="px-4 bg-[#1a1f26] text-gray-400">
                        O continuar con
                      </span>
                    </div>
                  </div>

                  <button
                    type="button"
                    onClick={() => {
                      // @ts-ignore
                      const win: any = window;
                      win.AppleID?.auth?.signIn?.().then((data: any) => {
                        if (data.authorization.id_token && data.authorization.id_token.length > 0) {
                          if (data.user) {
                            props.actions.newAppleLoginRequest(
                              data.authorization.id_token,
                              data.user.email,
                              data.user.name.firstName + data.user.name.lastName
                            );
                          } else {
                            props.actions.newAppleLoginRequest(data.authorization.id_token);
                          }
                        }
                      }).catch((e: any) => {});
                    }}
                    className="w-full py-3 px-4 bg-black text-white font-semibold rounded-xl hover:bg-gray-900 transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                    style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", sans-serif' }}
                  >
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                    </svg>
                    {tr(t, 'login_apple-login')}
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      // @ts-ignore
                      FB.login(
                        function (response: any) {
                          const fbToken = get(response, [
                            'authResponse',
                            'accessToken',
                          ]);
                          if (fbToken && fbToken.length > 0) {
                            props.actions.newFBLoginRequest(fbToken);
                          }
                        },
                        { scope: 'public_profile,email' },
                      );
                    }}
                    className="w-full py-3 px-4 bg-[#1877f2] text-white font-semibold rounded-xl hover:bg-[#166fe5] transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                    {tr(t, 'login_facebook-login')}
                  </button>
                </form>
              )}
            />
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  user: userSelector(state),
  isLoading: state.login.isLoading,
  loginError: state.login.error,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      newLoginRequest: loginActions.loginRequestAction,
      newFBLoginRequest: loginActions.fbLoginRequest,
      newAppleLoginRequest: loginActions.appleLoginRequest,
    },
    dispatch,
  ),
});

export const LoginConnected = withRouter(
  connect<StateProps, OwnProps, DispatchProps, RootState>(
    mapStateToProps,
    mapDispatchToProps,
  )(Login),
);
